import React, { useState } from 'react';

function AjudaTooltip({ texto }) {
  const [visivel, setVisivel] = useState(false);

  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      {/* botão ? */}
      <span
        onClick={() => setVisivel(!visivel)}
        style={{
          cursor: 'pointer',
          background: 'var(--azul-claro)',
          color: 'var(--azul-escuro)',
          borderRadius: '50%',
          width: 22,
          height: 22,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: 13,
          userSelect: 'none',
          flexShrink: 0,
        }}
      >
        ?
      </span>

      {/* popup de ajuda */}
      {visivel && (
        <>
          {/* overlay transparente para fechar ao clicar fora */}
          <div
            onClick={() => setVisivel(false)}
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              zIndex: 99,
            }}
          />
          <div style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            left: 0,
            zIndex: 100,
            background: 'var(--azul-escuro)',
            color: '#fff',
            padding: '14px 16px',
            borderRadius: 10,
            width: 'min(280px, calc(100vw - 32px))',
            fontSize: 13,
            lineHeight: 1.6,
            boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
            whiteSpace: 'pre-line',
          }}>
            {texto}
          </div>
        </>
      )}
    </div>
  );
}

export default AjudaTooltip;